module.exports = __webpack_public_path__ + "bc579317fa39ef6ff8da21cfa009f1b8.jpg";